// extracted by mini-css-extract-plugin
export default {"versionMessageContainer":"DocumentVersionMessage_versionMessageContainer__zrRSA","closeVersion":"DocumentVersionMessage_closeVersion__PPqTJ"};